import { c as _c } from "react/compiler-runtime";
import { popoverContentVariants } from "@/components/ui/menu-surface";
import { useOrderedOverlayContainer } from "@/components/ui/ordered-overlay";
import * as PopoverPrimitive from "@radix-ui/react-popover";
import type { VariantProps } from "class-variance-authority";
import * as React from "react";
import cn from "twsx";

/** Use when a trigger opens small, non-blocking content next to it. */
const Popover = PopoverPrimitive.Root;
const PopoverTrigger = PopoverPrimitive.Trigger;
const PopoverAnchor = PopoverPrimitive.Anchor;
const PopoverContent = t0 => {
  const $ = _c(22);
  let className;
  let container;
  let padding;
  let props;
  let ref;
  let t1;
  let t2;
  let width;
  if ($[0] !== t0) {
    ({
      className,
      padding,
      width,
      align: t1,
      sideOffset: t2,
      container,
      ref,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = container;
    $[3] = padding;
    $[4] = props;
    $[5] = ref;
    $[6] = t1;
    $[7] = t2;
    $[8] = width;
  } else {
    className = $[1];
    container = $[2];
    padding = $[3];
    props = $[4];
    ref = $[5];
    t1 = $[6];
    t2 = $[7];
    width = $[8];
  }
  const align = t1 === undefined ? "center" : t1;
  const sideOffset = t2 === undefined ? 4 : t2;
  const orderedContainer = useOrderedOverlayContainer();
  const t3 = container ?? orderedContainer ?? undefined;
  let t4;
  if ($[9] !== className || $[10] !== padding || $[11] !== width) {
    t4 = cn(popoverContentVariants({
      padding,
      width
    }), className);
    $[9] = className;
    $[10] = padding;
    $[11] = width;
    $[12] = t4;
  } else {
    t4 = $[12];
  }
  let t5;
  if ($[13] !== align || $[14] !== props || $[15] !== ref || $[16] !== sideOffset || $[17] !== t4) {
    t5 = <PopoverPrimitive.Content ref={ref} align={align} sideOffset={sideOffset} className={t4} {...props} />;
    $[13] = align;
    $[14] = props;
    $[15] = ref;
    $[16] = sideOffset;
    $[17] = t4;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== t3 || $[20] !== t5) {
    t6 = <PopoverPrimitive.Portal container={t3}>{t5}</PopoverPrimitive.Portal>;
    $[19] = t3;
    $[20] = t5;
    $[21] = t6;
  } else {
    t6 = $[21];
  }
  return t6;
};
PopoverContent.displayName = PopoverPrimitive.Content.displayName;
PopoverAnchor.displayName = PopoverPrimitive.Anchor.displayName;
PopoverTrigger.displayName = PopoverPrimitive.Trigger.displayName;
export { Popover, PopoverAnchor, PopoverContent, PopoverTrigger };